import React from 'react';
import {
  SelectFieldV2,
} from 'ui/FormElement';

import { useFormikContext } from 'formik';

import usePlans from 'components/Common/PolicyPlans/Hooks/usePlans';

export default function EnterprisePlan() {
  const {
    values: { enterprise },
  } = useFormikContext();

  const plans = enterprise ? usePlans({ enterpriseId: enterprise }) : null;

  let placeholder = 'Choose Enterprise first';

  if (enterprise !== null) {
    placeholder = plans == null
      ? 'Enterprise Plans is loading ...'
      : 'Choose Enterprise Plans...';
  }

  return (

    <SelectFieldV2
      name="enterprise_plans"
      label={(
        <span>Enterprise Plans</span>
            )}
      placeholder={placeholder}
      options={plans == null ? [] : plans.map((item) => ({
        label: item.attributes.name,
        value: item.id,
      }))}
      isMulti
      menuPlacement="top"
      styles={{
        menuPortal: (base) => ({ ...base, zIndex: 99999 }),
        control: (provided) => ({
          ...provided,
          maxHeight: '100px', // Adjust the maxHeight as needed
          minHeight: '100px', // Adjust the minHeight as needed
          overflowY: 'auto',
        }),
        multiValue: (provided) => ({
          ...provided,
          whiteSpace: 'nowrap', // Prevent the component from growing vertically
        }),
      }}
      menuPortalTarget={document.body}
    />
  );
}
